<div class="modal-header" *transloco="let t; prefix: 'parts.modals'">
  <h5 class="modal-title">{{ title }}</h5>
  <button
    type="button"
    class="btn-close"
    [attr.aria-label]="'common.close' | transloco"
    (click)="onCancel()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'parts.modals'">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- Work Order -->
    <div class="form-group">
      <label>{{ t('fields.workOrder') }}</label>
      <input
        class="form-control"
        type="text"
        [value]="workOrderNumber"
        disabled />
    </div>

    <!-- Single mode: Part Number + Description as separate fields -->
    @if (!isBulk && singlePart) {
      <div class="form-group">
        <label>{{ t('fields.partNumber') }}</label>
        <input
          class="form-control"
          type="text"
          [value]="singlePart.partNumber"
          disabled />
      </div>

      <div class="form-group">
        <label>{{ t('fields.description') }}</label>
        <input
          class="form-control"
          type="text"
          [value]="singlePart.description ?? ''"
          disabled />
      </div>
    }

    <!-- Bulk mode: Parts list card -->
    @if (isBulk) {
      <div class="form-group">
        <label>{{ t('fields.parts') }}</label>
        <div class="parts-list">
          @for (part of parts; track part.partNumber) {
            <div class="parts-list__item">
              <div class="parts-list__field">
                <span class="parts-list__field-label">{{ t('fields.partNumberColon') }}</span>
                <span class="parts-list__field-value">{{
                  part.partNumber
                }}</span>
              </div>
              <div class="parts-list__field">
                <span class="parts-list__field-label">{{ t('fields.descriptionColon') }}</span>
                <span class="parts-list__field-value">{{
                  part.description ?? ''
                }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Note -->
    <div class="form-group">
      <label>{{ t('fields.note') }}</label>
      <textarea
        class="form-control textarea"
        formControlName="note"
        [placeholder]="t('placeholders.addNotes')"
        rows="3">
      </textarea>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="cancel-btn"
        [disabled]="isLoading"
        (click)="onCancel()">
        {{ 'common.cancel' | transloco }}
      </button>
      <button type="submit" class="save-btn" [disabled]="isLoading">
        @if (isLoading) {
          <span class="spinner-border spinner-border-sm"></span>
        } @else {
          <span>{{ t('actions.save') }}</span>
        }
      </button>
    </div>
  </form>
</div>